export interface Skill {
  name: string;
  description: string;
}

export interface Project {
  name: string;
  description: string;
  image: string;
  tech_logos: tech_logo[];
}

export enum tech_logo {
  python = "python",
  react = "react",
  typescript = "typescript",
  javascript = "javascript",
  springboot = "springboot",
  java = "java",
  android = "android",
  reactnative = "reactnative",
  aws = "aws",
  firebase = "firebase",
  supabase = "supabase",
  django = "django",
  tanstack = "tanstack",
  prisma = "prisma",
  graphql = "graphql",
  apollo = "apollo",
  docker = "docker",
  figma = "figma",
  expo = "expo",
  kubernetes = "kubernetes",
}

export interface ProjectModalImage {
  path: string;
  objectFit: 'cover' | 'contain' | 'fill' | 'scale-down' | 'none';
  descriptiveTitle?: string;
}

export interface ProjectModalContent {
  title: string;
  paragraphs: (string | RichParagraph)[];  // Support both plain strings and rich paragraphs with links
  images: ProjectModalImage[];
}

export interface CompanyModalImage {
  path: string;
  objectFit: 'cover' | 'contain' | 'fill' | 'scale-down' | 'none';
  descriptiveTitle?: string;
}

// New interfaces for rich text with links
export interface TextLink {
  text: string;       // The text that will be clickable
  url: string;        // The URL the link points to
  newTab?: boolean;   // Whether to open in a new tab (defaults to true)
}

export interface ParagraphSegment {
  type: 'text' | 'link';
  content: string;
  link?: TextLink;
  bold?: boolean;  
}

export interface RichParagraph {
  segments: ParagraphSegment[];
}

export interface CompanyModalContent {
  title: string;
  // Replace simple string array with rich paragraphs
  paragraphs: (string | RichParagraph)[];  // Support both plain strings and rich paragraphs with links
  websiteLink: string;
  logo: string;
  images: CompanyModalImage[];
}

export interface ModalCarouselContent {
  content: ProjectModalContent[] | CompanyModalContent[]
}

export interface EducationListElement {
  title: string,
  timePeriod: number[],
  description: string
}

export interface Company {
  name: string;
  description: string;  // This remains a string as we'll extract text from rich paragraphs
  logo: string;
}
